
export const Inputs = [
    [

        {
            type: "text",
            label: { ar: "", en: "" },
            placeholder: { ar: "الكود", en: "Code" },
            title: { ar: " الكود", en: "Code" },
            name: "code",
            size: { lg: "12", md: "6" }
        },  
       
    ]

];

